import { Box, Skeleton } from '@mui/material';

import TableSkeleton from '@root/components/table/skeleton';
import PageContent from '@root/components/v2/layout/PageContent';
import PageHeaderSkeleton from '@root/components/v2/layout/PageHeader/Skeleton';

function RiskTableSkeleton() {
  return (
    <PageContent>
      <PageHeaderSkeleton />
      {/* <CloudProviderBarSkeleton /> */}

      <Box className="Borders RoundedCorners" marginBottom="15px" marginTop="25px">
        <Skeleton height="30px" style={{ transform: 'none' }} />
      </Box>

      <Box height={'63.7vh'}>
        <TableSkeleton />
      </Box>
    </PageContent>
  );
}

export default RiskTableSkeleton;
